module.exports = __webpack_public_path__ + "static/media/pin.03ecdae1.svg";